import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Spinner, Button, CardHeader, Table, UncontrolledTooltip, Modal, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router';
import _ from 'underscore';
import { Global } from '~/App'
import API from '~/API';
import GriddleCasero from '~/components/GriddleCasero'
import moment from 'moment';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar } from 'recharts';
import classnames from 'classnames';
import IngresaLectura from '~/IngresaLectura/Index';

class Consumos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datosConsumos: [],
            um: "",
            loadingConsumos: true,
            activeTab: '1',
            modalLectura: false,
            lecturas: null,
            loadingLecturas: false,
            puedeIngresarLectura: null
        };
    }

    getSafeProps = (propsObj) => {
        // Soporta la inyección de props empaquetadas desde index.js o props directas
        return propsObj.passedProps || propsObj;
    }

    componentDidMount() {
        const { Servicio } = this.getSafeProps(this.props);
        if (Servicio?.idServicio) {
            this.consultaConsumos();
            this.checkPuedeLectura();
        } else if (this.getSafeProps(this.props).Servicio) {
            // Si el objeto Servicio existe pero está incompleto
            this.props.history.replace("/administra");
        }
    }

    componentDidUpdate(prevProps) {
        const currentProps = this.getSafeProps(this.props);
        const pastProps = this.getSafeProps(prevProps);

        const idServicioActual = currentProps.Servicio?.idServicio;
        const empresaActual = currentProps.Servicio?.empresa;
        const idServicioAnterior = pastProps.Servicio?.idServicio;
        const empresaAnterior = pastProps.Servicio?.empresa;

        if (idServicioActual !== idServicioAnterior || empresaActual !== empresaAnterior) {
            if (idServicioActual) {
                this.setState({ lecturas: null, activeTab: '1' }, () => {
                    this.consultaConsumos();
                    this.checkPuedeLectura();
                });
            } else if (currentProps.Servicio) {
                this.props.history.replace("/administra");
            }
        }
    }

    consultaConsumos = async () => {
        const { Servicio } = this.getSafeProps(this.props);
        if (!Servicio?.idServicio || !Servicio?.empresa) return;

        this.setState({ loadingConsumos: true });
        try {
            const consumosData = await API.Call(`Consulta/${Servicio.empresa}/Cartola/Consumos/${Servicio.idServicio}/${moment().add(-13, 'month').format("DDMMYYYY")}/${moment().add(1, 'month').format("DDMMYYYY")}`);
            let newUm = "";
            const processedConsumos = _.map(consumosData?.Documentos || [], e => {
                if (!e) return e;
                e.fechaformato = moment(e.fecha_lectura).format("MMM YYYY");
                newUm = e.nom_unid_med || "m³";
                return e;
            }).reverse();

            this.setState({
                datosConsumos: processedConsumos,
                um: newUm
            });
        } catch (error) {
            console.error("Error fetching consumption data:", error);
        } finally {
            this.setState({ loadingConsumos: false });
        }
    }

    consultaLecturas = async () => {
        const { Servicio } = this.getSafeProps(this.props);
        if (!Servicio?.idServicio || !Servicio?.empresa) return;

        this.setState({ loadingLecturas: true });
        try {
            const lecturasData = await API.Call(`Consulta/${Servicio.empresa}/Medidor/Lecturas/${Servicio.idServicio}`);
            const sortedLecturas = Array.isArray(lecturasData)
                ? lecturasData.sort((a, b) => moment(b.fecha).diff(moment(a.fecha)))
                : [];
            this.setState({ lecturas: sortedLecturas });
        } catch (error) {
            console.error("Error fetching readings:", error);
            this.setState({ lecturas: [] });
        } finally {
            this.setState({ loadingLecturas: false });
        }
    }

    checkPuedeLectura = async () => {
        const { Servicio } = this.getSafeProps(this.props);
        if (!Servicio?.idServicio || !Servicio?.empresa) return;
        try {
            const puede = await API.Call(`Consulta/${Servicio.empresa}/Puede/Lectura/`, { IdServicio: Servicio.idServicio, Fecha: moment() });
            this.setState({ puedeIngresarLectura: puede && puede.ok ? puede : null });
        } catch (error) {
            this.setState({ puedeIngresarLectura: null });
        }
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab }, () => {
                if (tab === '2' && !this.state.lecturas) {
                    this.consultaLecturas();
                }
            });
        }
    };

    abrirModalLectura = () => this.setState({ modalLectura: true });
    cerrarModalLectura = () => this.setState({ modalLectura: false });

    renderConsumosTab = () => {
        const { loadingConsumos, datosConsumos, um } = this.state;

        if (loadingConsumos) {
            return <TabPane tabId="1"><div className="text-center p-5"><Spinner /></div></TabPane>;
        }

        const columns = [
            { key: "nombre_clave_lectura", name: "Tipo Lectura" },
            { key: "fechaformato", name: "Periodo" },
            { key: "fecha_lectura", name: "Fecha Lectura", formatter: "fecha", right: true },
            { key: "consumo_facturado_ap", name: `Agua Potable [${um}]`, right: true, formatter: "derecha" },
            { key: "consumo_facturado_al", name: `Alcantarillado [${um}]`, right: true, formatter: "derecha" }
        ];
        const rows = _.sortBy(datosConsumos || [], d => moment(d.fecha)).reverse();

        return (
            <TabPane tabId="1">
                <Row>
                    <Col sm={12} className="mt-3">
                        <ResponsiveContainer width={"100%"} height={250}>
                            <BarChart data={datosConsumos}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="fechaformato" />
                                <YAxis tickFormatter={t => `${Global.FormatearNumero ? Global.FormatearNumero(t) : t} ${um}`} />
                                <Tooltip formatter={(value) => [`${Global.FormatearNumero ? Global.FormatearNumero(value) : value} [${um}]`, "Consumo"]} />
                                <Bar dataKey="consumo_facturado_ap" className="grafico-barras1" />
                            </BarChart>
                        </ResponsiveContainer>
                        <hr /><br />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className="bordeIzquierdo tablaConsumos">
                        <div className="d-none d-md-block">
                            {rows.length > 0 ? <GriddleCasero data={rows} columns={columns} /> : <p className="text-center text-muted">No se encontraron consumos.</p>}
                        </div>
                        <div className="d-md-none">
                            {rows.length > 0 ? rows.map((item, index) => (
                                <Card key={index} className="mb-3">
                                    <CardBody>
                                        <p><i className="fa fa-tag mr-2" /><strong>Tipo Lectura:</strong> {item.nombre_clave_lectura}</p>
                                        <p><i className="fa fa-calendar mr-2" /><strong>Periodo:</strong> {item.fechaformato}</p>
                                        <p><i className="fa fa-calendar-o mr-2" /><strong>Fecha Lectura:</strong> {moment(item.fecha_lectura).format("DD/MM/YYYY")}</p>
                                        <p><i className="fa fa-tint mr-2" /><strong>Agua Potable [{um}]:</strong> {Global.FormatearNumero ? Global.FormatearNumero(item.consumo_facturado_ap) : item.consumo_facturado_ap}</p>
                                        <p><i className="fa fa-tint mr-2" /><strong>Alcantarillado [{um}]:</strong> {Global.FormatearNumero ? Global.FormatearNumero(item.consumo_facturado_al) : item.consumo_facturado_al}</p>
                                    </CardBody>
                                </Card>
                            )) : <p className="text-center text-muted">No se encontraron consumos.</p>}
                        </div>
                    </Col>
                </Row>
            </TabPane>
        );
    };

    renderLecturasTab = () => {
        const { medidorInfo } = this.getSafeProps(this.props);
        const { lecturas, loadingLecturas, puedeIngresarLectura } = this.state;

        const MedidorCard = (
            <Col md="4" className="mb-3">
                <Card className="h-100">
                    <CardHeader><h5><i className="fa fa-tachometer mr-2" />Información del Medidor</h5></CardHeader>
                    <CardBody>
                        {medidorInfo ? <>
                            <p><strong>N° Medidor:</strong> {medidorInfo.no_medidor || 'No disponible'}</p>
                            <p><strong>Tipo:</strong> {medidorInfo.nom_tipo_medidor || 'No disponible'}</p>
                            <p><strong>Marca:</strong> {medidorInfo.nom_marca || 'No disponible'}</p>
                            <p><strong>Modelo:</strong> {medidorInfo.nom_modelo || 'No disponible'}</p>
                            <p><strong>Año Fabricación:</strong> {medidorInfo.ano_fabricacion || 'No disponible'}</p>
                            <p><strong>Fecha Instalación:</strong> {medidorInfo.fecha_instalacion ? moment(medidorInfo.fecha_instalacion).format("DD/MM/YYYY") : 'No disponible'}</p>
                            <p><strong>Lectura Remota:</strong> {medidorInfo.b_lectura_remota ? 'Sí' : 'No'}</p>
                        </> : <div className="text-center p-5"><Spinner size="sm" /></div>}
                    </CardBody>
                </Card>
            </Col>
        );

        const LecturasCard = (
            <Col md="8">
                <Card className="h-100">
                    <CardHeader><h5><i className="fa fa-history mr-2" />Historial de Lecturas</h5></CardHeader>
                    <CardBody>
                        {loadingLecturas ? <div className="text-center p-5"><Spinner /></div> :
                            lecturas && lecturas.length > 0 ? (
                                <Table responsive hover striped>
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th className="text-right">Lectura</th>
                                            <th>Estado</th>
                                            <th>Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lecturas.map((lectura, index) => (
                                            <tr key={index}>
                                                <td>{moment(lectura.fecha).format("DD/MM/YYYY")}</td>
                                                <td className="text-right">{Global.FormatearNumero ? Global.FormatearNumero(lectura.lectura) : lectura.lectura}</td>
                                                <td>
                                                    <span className={`badge badge-${lectura.es_efectiva ? 'success' : 'warning'}`}>
                                                        {lectura.nom_clave_lectura}
                                                    </span>
                                                </td>
                                                <td>
                                                    {!lectura.es_efectiva && index === 0 && (
                                                        puedeIngresarLectura ? (
                                                            <>
                                                                <Button color="primary" size="sm" onClick={this.abrirModalLectura} id={`informar-lectura-${index}`}>
                                                                    Informar Lectura
                                                                </Button>
                                                                <UncontrolledTooltip placement="top" target={`informar-lectura-${index}`}>
                                                                    Su última lectura fue irregular. Puede informarnos la lectura actual para ayudar a estimar correctamente su próximo consumo.
                                                                </UncontrolledTooltip>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Button color="secondary" size="sm" disabled id={`informar-lectura-disabled-${index}`}>
                                                                    Informar Lectura
                                                                </Button>
                                                                <UncontrolledTooltip placement="top" target={`informar-lectura-disabled-${index}`}>
                                                                    Su última lectura fue irregular. Sin embargo, el período para informar la lectura de este mes ha finalizado. Por favor, inténtelo en el próximo ciclo de facturación.
                                                                </UncontrolledTooltip>
                                                            </>
                                                        )
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="text-center text-muted">No hay historial de lecturas disponible.</p>
                            )}
                    </CardBody>
                </Card>
            </Col>
        );

        return (
            <TabPane tabId="2">
                <Row className="mt-3">
                    {MedidorCard}
                    {LecturasCard}
                </Row>
            </TabPane>
        );
    };

    render() {
        const { Servicio, Usuario } = this.getSafeProps(this.props);
        const { loadingConsumos, activeTab, modalLectura, puedeIngresarLectura } = this.state;

        if (!Servicio) {
            return <div className="text-center p-5"><Spinner style={{ width: '3rem', height: '3rem' }} /><h4>Cargando...</h4></div>;
        }

        if (loadingConsumos) {
            return <div className="text-center p-5"><Spinner style={{ width: '3rem', height: '3rem' }} /><h4>Cargando...</h4></div>;
        }

        return (
            <div>
                <Nav tabs>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === '1' })} onClick={() => this.toggle('1')}>
                            <i className="fa fa-bar-chart mr-2" />Consumos
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === '2' })} onClick={() => this.toggle('2')}>
                            <i className="fa fa-file-text-o mr-2" />Lecturas y Medidor
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                    {this.renderConsumosTab()}
                    {this.renderLecturasTab()}
                </TabContent>
                <Modal size="lg" wrapClassName="asyntec-portal-clientes" isOpen={modalLectura} toggle={this.cerrarModalLectura}>
                    <ModalBody>
                        <IngresaLectura
                            IngresarLectura={{ servicio: Servicio.idServicio, empresa: Servicio.empresa, proceso: puedeIngresarLectura?.proceso }}
                            Usuario={Usuario}
                            FuncionCerrar={this.cerrarModalLectura}
                            FuncionOk={() => {
                                this.cerrarModalLectura();
                                this.consultaLecturas();
                                this.checkPuedeLectura();
                            }}
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Consumos);